export const defaultFormVal = {
  "subject": "",
  "content": "",
  "customer_support_reminder_subject": "",
  "customer_support_reminder_content": "",
  "customer_support_reminder_duration": 0,
  "emails": []
}